import React, {Fragment} from "react";
import {APP} from "../../../constants";
import moment from "moment";
import styled from "styled-components";
import {Link, NavLink} from "react-router-dom";
import {Label, Responsive} from "semantic-ui-react";
import {
    FacebookIcon,
    FacebookShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from "react-share";
import {FormattedMessage} from "react-intl";

const getWidth = () => {

    const isSSR = typeof window === 'undefined';

    return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
};

export const Featured = ({post, read, path, pages}) => {

    if (!post.id) {
        return null;
    }

    const {id, title, slug, category, category_id, created_at} = post;

    const image = APP.API_URL + '/files/posts/image/' + post.image;
    const image_credit = post.image_credit || undefined;
    const created = moment(created_at);

    const Wrapper = styled.div`
      margin-bottom: 2em;
    `;

    const Image = styled.div`
      background-image: url(${image});
    `;

    const Row = styled.div`
        display: flex;
        flex-direction: row;
        margin-top: .5rem;
        & > div {
            display: flex;
            width: 50%;
        }        
        & > div:last-child{
            justify-content: flex-end;
        }
    `;

    document.getElementsByTagName("META")[1].content = title;

    if (read && image) {

        document.getElementsByTagName("META")[2].content = image;
    }

    if (read && pages) {
        return (
            <Wrapper>
                <div>{read ? <h2>{title}</h2> : title}</div>
            </Wrapper>
        );
    }

    const getContent = (id, title, created, read, category = false, path) => {

        const shareUrl = 'https://br.inbh.com.br/posts/share/' + id;

        return (
            <React.Fragment>
                <Image className={`post-image ${image_credit && "credits"}`}/>
                {image_credit && <small><FormattedMessage id={"Créditos"}/>: {image_credit}</small>}
                {/*<div>{read ? <h2>{title}</h2> : title}</div>*/}
                <div className="ui header">{title}</div>
                <Row>
                    <div>
                        <Label content={created.format('MMM D,Y')}/>
                    </div>
                    {
                        read && <div className={'share'}>

                            <FacebookShareButton
                                url={shareUrl}
                                quote={title}
                            >
                                <FacebookIcon
                                    size={24}
                                    round
                                />
                            </FacebookShareButton>

                            <TwitterShareButton
                                url={`${shareUrl}?fbclid=2`}
                                title={title}
                            >
                                <TwitterIcon
                                    size={24}
                                    round
                                />
                            </TwitterShareButton>

                            <WhatsappShareButton
                                url={`${shareUrl}?fbclid=1`}
                                title={title}
                                separator=":: "
                            >
                                <WhatsappIcon
                                    size={24}
                                    round
                                />
                            </WhatsappShareButton>
                        </div>
                    }
                    <div>
                        {
                            category.id && <NavLink
                                to={`${path}/home/${category.id}/${category.slug}`}
                                className={'ui red label'}
                            >{category.name}</NavLink>
                        }
                    </div>
                </Row>
            </React.Fragment>
        );
    };

    if (read) {
        return (
            <Wrapper
                className={'post-featured'}
            >
                {getContent(id, title, created, read, category, path)}
            </Wrapper>
        );
    }

    return (

        <Wrapper
            className={'post-featured'}
        >
            <Link
                to={`${path}/read/${id}/${slug}?category=${category_id}`}
            >
                {getContent(id, title, created)}
            </Link>
        </Wrapper>
    );
};